import { render, staticRenderFns } from "./courier-express-delivery-create.vue?vue&type=template&id=898f826e&"
import script from "./courier-express-delivery-create.vue?vue&type=script&lang=ts&"
export * from "./courier-express-delivery-create.vue?vue&type=script&lang=ts&"
import style0 from "./courier-express-delivery-create.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports